import { Link } from "react-router-dom";

const CREDIT_STYLE = {
  fontFamily: "monospace",
  fontSize: "10px",
  color: "#444444",
  textAlign: "right",
  margin: "4px 8px 0 0",
};

export default function GuideHero({ image, alt, eyebrow, title, photographerName, objectPosition, imageUrl }) {
  return (
    <div>
      <div style={{ position: "relative", height: 300, overflow: "hidden" }}>
        <img
          src={image}
          alt={alt}
          style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: objectPosition || "center", display: "block" }}
        />
        <div style={{
          position: "absolute", inset: 0,
          background: "linear-gradient(to bottom, rgba(0,0,0,0.25), rgba(17,17,17,0.88))",
          display: "flex", flexDirection: "column", justifyContent: "flex-end",
          padding: "2rem clamp(1rem, 5vw, 4rem)",
        }}>
          <p className="eyebrow eyebrow-red mb-2">
            <Link to="/guides" className="hover:underline">// GUIDES</Link>
            {eyebrow && <span> / {eyebrow}</span>}
          </p>
          <h1 className="font-mono text-2xl md:text-4xl text-white uppercase tracking-tight leading-tight">
            {String(title).split("\n").map((line, i) => (
              <span key={i}>{line}{i < String(title).split("\n").length - 1 && <br />}</span>
            ))}
          </h1>
        </div>
      </div>
      {photographerName && (
        <p style={CREDIT_STYLE}>{photographerName}</p>
      )}
    </div>
  );
}
